import type { ShopInfo } from '../../lib/twin';

interface Props {
  shop: ShopInfo;
}

/** About / brand story — short, warm, conversion-supporting. */
export function AboutSection({ shop }: Props) {
  return (
    <section
      id="about"
      aria-labelledby="about-heading"
      className="bg-espresso text-cream-50"
    >
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 sm:py-20 lg:grid-cols-2 lg:items-center">
        <div aria-hidden="true" className="order-last lg:order-first">
          <div className="flex aspect-[4/3] items-center justify-center rounded-[2rem] bg-gradient-to-br from-mocha to-espresso-soft ring-1 ring-white/10">
            <span className="text-7xl">🫘</span>
          </div>
        </div>

        <div>
          <h2 id="about-heading" className="text-3xl font-bold sm:text-4xl">
            Our story
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-cream-100">
            {shop.name} started with a simple idea: great coffee shouldn't be
            complicated. We roast in small batches right here in the{' '}
            {shop.neighborhood}, pull every shot to order, and count every bean so
            nothing goes to waste.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-cream-100">
            Whether you tap through the menu or chat with our barista bot, you get
            the same friendly cup — made fast, made fresh, made for your morning.
          </p>
        </div>
      </div>
    </section>
  );
}
